import {
    ANNOTATION_VIDEO_DISPLAY,
    // ANNOTATION_PARENT,
    VIDEO_PLAYING_MODE,
    // ANNOTATION_LOCATION,
    // VIDEO_SRC_TYPE
} from './GlobalConstants';
// import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';
// export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/Liana-Cheney-Barbara-Longhi%2F";
export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/Liana-Cheney-Barbara-Longhi%2Fversion-2%2F";
export const ANNOTATION_TEXT_ALIGNMENT = "left";
export const ANNOTATION_TEXT_LINE_HEIGHT = "1.5";
export const GALLERY_LINK_LABEL = "TROUBLESHOOTING";

const INFO_TAG = '/assets/sprites/project_sprites/Info.svg';


const AnnotationsDB = [
    /* Text Annotations */
    {
        paintingId: "G01F01AP01",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G01F01AP01.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G02F02AP02",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G02F02AP02.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G02F02BP03",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G02F02BP03.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G03F03AP04",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G03F03AP04.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G03F03BP05",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G03F03BP05.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G03F32AP06",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G03F32AP06.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G03F33AP07",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G03F33AP07.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G03F34AP08",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G03F34AP08.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G04F12AP09",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G04F12AP09.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G04F13AP10",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G04F13AP10.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G04F14AP11",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G04F14AP11.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G04F15AP12",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G04F15AP12.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G04F16AP13",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G04F16AP13.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G04F17AP14",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G04F17AP14.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G04F18AP15",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G04F18AP15.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N",
        // annotation_location_vert_offset: -1.2,
        annotation_location_horiz_offset: -0.18,
    },
    {
        paintingId: "G04F19AP16",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G04F19AP16.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G05F05AP17",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G05F05AP17.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G05F06AP18",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G05F06AP18.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G05F07AP19",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G05F07AP19.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G06F04AP20",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G06F04AP20.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G06F10AP21",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G06F10AP21.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G06F20AP22",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G06F20AP22.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G06F21AP23",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G06F21AP23.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G07F09AP24",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G07F09AP24.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G07F23AP25",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G07F23AP25.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G07F22AP26",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G07F22AP26.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G07F11AP27",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G07F11AP27.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G08F27AP28",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G08F27AP28.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G08F25AP29",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G08F25AP29.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G08F26AP30",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G08F26AP30.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G09F08AP31",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G09F08AP31.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G09F28AP32",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G09F28AP32.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G10F29AP33",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G10F29AP33.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G10F30AP34",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G10F30AP34.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G10F35AP35",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G10F35AP35.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    },
    {
        paintingId: "G11F24AP36",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G11F24AP36.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N",
        annotation_location_vert_offset: -1.2,
        annotation_location_horiz_offset: -0.05,
    },
    {
        paintingId: "G11F31AP37",
        videoId: "",
        videoURL: "",
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}G11F31AP37.jpg/info.json`,
        headerText: "<h5></h5>",
        bodyText: "<i></i><br><br>",
        displayMesh: "Y",
        useMeshButton: "N"
    }
    /* Text Annotations */
];

export {AnnotationsDB};
